import { render } from "./FAQDetail.vue?vue&type=template&id=4f2f95cc"
import script from "./FAQDetail.vue?vue&type=script&lang=js"
export * from "./FAQDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__